import Navbar from "./Components/navbar/Navbar"
import Intro from "./Components/intro/Intro";
import About from "./Components/about/About"
import Services from "./Components/services/Services"
import Works from "./Components/works/Works";
import Portfolio from "./Components/portfolio/Portfolio";
import Testimonials from "./Components/testimonials/Testimonials";
import Contact from "./Components/contact/Contact"
import Footer from "./Components/footer/Footer"


import './App.css'
function App() {
  return (
    <>
    <div><Navbar/>
    </div>
    <div className="App">
      
     
     <Intro/>
     <About/>
     
     <Services/>
     <Works/>
     <Portfolio/>
    
     <Testimonials/>
     <Contact/> </div>
     
     <div>
     <Footer/>
    </div>
    </>

  );
    
}

export default App;
